import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import Text from '../../Text'

import * as styles from './TableModalInitialError.module.css'

function TableModalInitialError(props) {
  const { t } = useTranslation()

  const {
    buttonText = t('Notification.RefreshButtonTextKey'),
    className = styles.TableModalInitialError,
    errorText = t('Notification.ModalDataErrorTitleKey'),
  } = props

  return (
    <div className={className}>
      <Text isSecondary className={styles.text}>
        {errorText}
      </Text>
      <Button.Text
        className={styles.button}
        text={buttonText}
        onClick={props.onRefresh}
      />
    </div>
  )
}

export default TableModalInitialError
